import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { observer } from 'mobx-react';
import { ComponentJSSClasses } from './styles';
import { CategoryRatingShort } from '../../CategoryRatingShort';
import { AdditionalRating, CategoryRu } from '../../../../../models/hotel-reviews';

export interface DetailInfographicProps {
    additionalRating: AdditionalRating;
}

interface StyledDetailInfographicProps
    extends JSSClassesProps<ComponentJSSClasses>,
        DetailInfographicProps {}

export const DetailInfographic = observer(
    (props: StyledDetailInfographicProps) => {
        const { classes, additionalRating } = props;

        return (
            <div className={classes.container}>
                <CategoryRatingShort rating={additionalRating.Room} category={CategoryRu.Room} />
                <CategoryRatingShort rating={additionalRating.Location} category={CategoryRu.Location} />
                <CategoryRatingShort rating={additionalRating.Service} category={CategoryRu.Service} />
                <CategoryRatingShort rating={additionalRating.PriceQuality} category={CategoryRu.PriceQuality} />
                <CategoryRatingShort rating={additionalRating.Clean} category={CategoryRu.Clean} />
                <CategoryRatingShort rating={additionalRating.Meal} category={CategoryRu.Meal} />
            </div>
        );
    }
);
